import React, { useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, Typography } from '@mui/material';
import { Spin } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import DataTypeTable from '../../../../Types/DataTypeTable';
import COMPTES from '../../../../Models/Comptes';
import CheckBox from '../../../CheckBox';
import axios from 'axios';
import SweetAlert from 'sweetalert2'

interface SelectData {
    value: string,
    label: string,
}


function Tab6(props: { form?: any }) {
    const [accounts, setAccounts] = React.useState<SelectData[]>([]);
    const [Donnee, setDonnee] = React.useState<COMPTES[]>([]);
    const [message, setMessage] = React.useState<String>("");
    const [statut, setStatut] = React.useState<number>();
    //const [pageIsLoad, setPageIsLoad] = useState(true);
    const [loading, setLoading] = useState(false);
    const [valeur, setvaleur] = useState<string>();
    const [montant, setMontant] = useState<number>(0);
    const [pourcentage, setPourcentage] = useState<number>(0);
    const [valeursDeGarantie, setValeursDeGarantie] = useState<number>(0)
    const [loadCompteEngagement, setLoadCompteEngagement] = useState(false);
    const[loadAc, setLoadAc] = useState(false)

    // USER TOKEN
    const authHeader = useAuthHeader()

    const columns: ColumnsType<COMPTES> = [
        {
            title: 'N° Compte',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'Nom Compte',
            dataIndex: 'NOMCPT',
        },
        {
            title: 'Plan comptable',
            dataIndex: 'IDPLAN',
        },
        {
            title: 'Nom Plan comptable',
            dataIndex: 'LIBPLAN',
        },
        {
            title: 'Type Compte',
            dataIndex: 'TYPCPT',
        },
        {
            title: 'Date Création',
            dataIndex: 'DATCRE',
        },
    ];

    //   function loadAccount() {
    //     try {

    //       const datat: SelectData[] = [];
    //       var cpts = JSON.parse((Crypter.decrypt(localStorage.getItem("comptes_client") + "")))

    //       //alert(gats)

    //       if (cpts.length === 0) {
    //         //console.log("aucun élément ");
    //         setAccounts(datat)
    //       }
    //       else {
    //         cpts.map((data: COMPTES) => {
    //           //console.log(JSON.stringify(data))
    //           datat.push({
    //             value: data.NUMCPT,
    //             label: data.NUMCPT + ' -> ' + data.NOMCPT,
    //           });
    //           setAccounts(datat);
    //         })
    //       }
    //     } catch (error) {
    //       //SweetAlert.fire({title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning"})
    //       setvaleur('')
    //       setAccounts([])
    //     }


    //   }

    function loadData() {
        try {
            setMessage("")
            let data = JSON.parse(Crypter.decrypt(localStorage.getItem("comptes_client") + ""))
            let msg = JSON.parse(Crypter.decrypt(localStorage.getItem("message_comptes_client") + ""))
            //alert(JSON.stringify(data))

            //   let v = 0
            //   data.map((d: DataTypeTable) => {
            //     v += d.valCouvert;
            //   })
            //   setValeursDeGarantie(v)
            //props.form.setFieldValue("montantGarantieCouvert", v)
            setDonnee(data)
            setMessage(msg[0].msg)
            setStatut(parseInt(msg[0].statut))

        } catch (error) {
            console.log(error)
        }
    }
    setTimeout(() => {
        if (Donnee.length == 0) {
            loadData()
            //loadAccount()
        }
        try {
            let reset = localStorage.getItem(Datas.LocalVariable.reset)
            if (reset == "1") {
                setAccounts([])
                setDonnee([])
                setMessage("")
                setStatut(undefined)
                //setvaleur("")
                //setMontant(0)
                //setPourcentage(0)
                //setValeursDeGarantie(0)
                localStorage.removeItem("comptes_client")
                localStorage.removeItem("message_comptes_client")
                //localStorage.clear()
            }
        }
        catch (error) { }
    }, .1);

    function GenerateCompteEngagement(check: any) {
        //props.form.setFieldValue("generateNewAccount", check)
        localStorage.setItem("generateNewAccount", check)
        if (check) {
            setLoading(true)
            setAccounts([])
            let NUMDOS = Crypter.encrypt(props.form.getFieldValue("NUMDOS"))
            //alert(NUMDOS)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetCompteEngagement,
                headers: {
                    'CipherNumDos': NUMDOS,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };
            axios.request(config)
                .then((response) => {
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        console.log(res)
                        if (res.StatutCode == 200) {
                            
                            //alert(JSON.stringify(res))
                            setDonnee(res.Result.Table)

                        }
                        else {
                            SweetAlert.fire({ title: res.Message, icon: "warning" })
                        }
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: error, icon: "error" })
                });
        } else {
            let data = JSON.parse(Crypter.decrypt(localStorage.getItem("comptes_client") + ""))
            setDonnee(data)
        }
    }


    return (
        <Spin spinning={loading} size='large' style={{ color: 'green' }} >
            <div className='tabItem'>
                <div>
                    <Box fontStyle="inherit">
                        <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
                            <legend>Compte d'engagement relié</legend>
                            <div>
                                <Table size='small' columns={columns} scroll={{ x: 250, y: 180 }} pagination={false} dataSource={Donnee} />
                            </div>
                            <Box fontStyle={"inherit"} marginTop={2} display={"flex"}>
                                <Typography marginLeft={1} color={statut == 200 ? "green" : "yellowgreen"}>{message}</Typography>
                                {statut == 202 ?
                                    <Box marginLeft={10} marginTop={-2}>
                                        <CheckBox checked={loadAc} onClick={()=>{setLoadAc(!loadAc); GenerateCompteEngagement(!loadAc)}} disabled={false} notRequired label='Générer de nouveu comtes? ' form={props.form} name='generateNewAccount' />
                                    </Box>
                                    :
                                    ""}
                            </Box> 
                        </Box>
                    </Box>
                </div>
            </div>
        </Spin>
    );
}
export default Tab6;